/**
 * token存储到cookie
 */

import cookies from 'js-cookie';

const tokenKey = 'Admin-Token';                 // 用户信息

// 设置缓存
export function setToken(token) {
    cookies.set(tokenKey, token);
};

// 获取缓存
export function getToken() {
    return cookies.get(tokenKey);
};

// 去除缓存
export function removeToken() {
    cookies.remove(tokenKey);
};

const buttonAuthKey = 'Button-Auth';

// 设置按钮权限
export function setButtonsAuth(auths) {
    return sessionStorage.setItem(buttonAuthKey, JSON.stringify(auths));
}

// 获取按钮权限
export function getButtonsAuth() {
    return JSON.parse(sessionStorage.getItem(buttonAuthKey));
}